import Data from './Data';

const Sidebar = (props) => {
  return <Data {...props} />;
};

export default Sidebar;
